import { render, staticRenderFns } from "./ApiDocumentation.vue?vue&type=template&id=1c2416cb&scoped=true&"
import script from "./ApiDocumentation.vue?vue&type=script&lang=js&"
export * from "./ApiDocumentation.vue?vue&type=script&lang=js&"
import style0 from "./ApiDocumentation.vue?vue&type=style&index=0&id=1c2416cb&lang=scss&scoped=true&"
import style1 from "./ApiDocumentation.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c2416cb",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VContainer,VRow})
